import { FormattedMessage } from "react-intl";
import { seriesManagement } from "./seriesManagement";
import { topicManagement } from "./topicManagement";
import { roleMenuList } from "../../roleMenuList";
import { featureList } from "../../featureList";

export let organize = {
  topicName: <FormattedMessage id="TOPICMANAGEMENT_TEXT" />,
  seriesName: <FormattedMessage id="PROGRAMMANAGEMENT_TEXT" />,
  path: (tenantName) => `/${tenantName}/organize`,
  buttons: (navigate, tenantName) => [
    {
      key: 1,
      label: topicManagement.name,
      path: topicManagement.path(tenantName),
      icon: topicManagement.icon,
      onClick: () => navigate(topicManagement.path(tenantName)),
      // name: [roleMenuList?.ORGANIZE?.TOPIC_MANAGEMENT],
      feature: [
        {
          roleMenu: roleMenuList?.ORGANIZE?.TOPIC_MANAGEMENT,
          MSOMMenu: featureList?.TOPIC_MGMT,
        },
      ],
    },
    {
      key: 2,
      label: seriesManagement.name,
      path: seriesManagement.path(tenantName),
      icon: seriesManagement.icon,
      onClick: () => navigate(seriesManagement.path(tenantName)),
    },
  ],
};
